import { getCourseInstancePath } from 'components/dashboard/ClassCard/helpers'
import { DWB_LESSONS_BASE_PATH } from 'containers/Product/constants'
import { getSlug } from 'utils/urlHelpers'

import { UNIT_ROUTE_PRODUCT_NAMES } from './constants'

const getDigitalWellBeingProductPreviewPath = courseOrSlug => {
  const gradeSlug =
    typeof courseOrSlug === 'string'
      ? courseOrSlug
      : courseOrSlug?.slug ||
        getSlug(courseOrSlug?.title || courseOrSlug?.displayTitle || '')

  return `${DWB_LESSONS_BASE_PATH}/preview/${gradeSlug}`
}

export function courseSelectHandlerFactory(productName, navigationEvent) {
  return courseOrSlug => () => {
    if (productName === 'digital-well-being') {
      return navigationEvent(
        getDigitalWellBeingProductPreviewPath(courseOrSlug),
      )
    }

    return navigationEvent(
      `/product/${productName}/lessons/preview/${courseOrSlug}`,
    )
  }
}

export function classSelectHandlerFactory(productName, navigationEvent) {
  return (course, instance) => () => {
    const usesUnitRoute = UNIT_ROUTE_PRODUCT_NAMES.includes(productName)

    if (usesUnitRoute) {
      const path = getCourseInstancePath({
        program: productName,
        gradeDisplayTitle: course,
        instance,
        tier: 1,
      })
      navigationEvent(path)
      return
    }

    navigationEvent(
      `/product/${productName}/lessons/teach/${course}?class=${instance}`,
    )
  }
}

export function gotoDashboardHandlerFactory(navigationEvent) {
  return () => navigationEvent('/')
}
